module.exports = __webpack_public_path__ + "static/media/UP_L4.99f3a2a2.svg";